import { ExternalRedirectRoute } from '../Routing/types';
const redirects: ExternalRedirectRoute[] = [
  {
    path: '/contact',
    externalRedirectTo: {
      'en-US': 'https://shestrong.zendesk.com/hc/en-us',
      'sv-SE': 'https://shestrongse.zendesk.com/hc/sv-se',
    },
  },
];

export default redirects;
